/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {AssetVehicleIcon} from '../icons/AssetVehicleIcon';
import {GroupChooserIcon} from '../icons/current/GroupChooserIcon';
import Render from '../render/Render';
import {dlsColor} from '../theme/theme';
import {IconSize} from '../types/types';

/**
 * Defines the props of `FilterTreeNodeIconView`: whether the icon is an asset
 * icon, and the color the icon is drawn in - `grey1` when omitted.
 */
export interface FilterTreeNodeIconViewProps {
  color?: string;
  isAsset: boolean;
}

/**
 * Renders the node icon in the given color, without a theme subscription - for
 * a parent that already re-renders on a theme mode change, such as
 * `FilterTreeChecklistNodeRow`. The color defaults to `grey1`, resolved on
 * each render.
 *
 * ```typescript
 * import {FilterTreeNodeIconView} from '@ion/dls/src/filters/FilterTreeNodeIconView';
 *
 * ...
 *
 * <FilterTreeNodeIconView isAsset />
 * ```
 */
export const FilterTreeNodeIconView = ({color = dlsColor('grey1'), isAsset}: FilterTreeNodeIconViewProps) => (
  <Render>
    <Render.If condition={isAsset}>
      <AssetVehicleIcon size={IconSize.large} color={color as any} />
    </Render.If>
    <Render.Else>
      <GroupChooserIcon size={IconSize.medium} color={color as any} />
    </Render.Else>
  </Render>
);
